"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedSharing = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const web_env_1 = require("@snapchat/web-env");
const react_1 = require("react");
const shareDestinations_1 = require("../../shareDestinations");
const event_1 = require("@snapchat/ts-protos/event");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const EmbedSharingModal_1 = require("./EmbedSharingModal");
const EmbedSharing_module_css_1 = __importDefault(require("./EmbedSharing.module.css"));
const react_intl_1 = require("react-intl");
const clsx_1 = __importDefault(require("clsx"));
const EmbedTriggers_1 = require("./EmbedTriggers");
/**
 * Embed Sharing Component to add embed button to the share bar and render embed modal
 */
function EmbedSharing({ triggerComponent = EmbedTriggers_1.EmbedTriggerComponent.ShareBar, shareDestinations, incrementCounter, pageName, pageType, shareLink, title, iframeURL, isMobile, className = "", }) {
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const timerRef = (0, react_1.useRef)();
    const webClientId = (0, web_sc_cookies_1.useGetWebClientId)() ?? "";
    const intl = (0, react_intl_1.useIntl)();
    const emitSuccessMetrics = (pageType, pageName, clickedMedia, shareSheetDestinations) => {
        void incrementCounter(`${pageName}.Embed.Desktop.Share.${clickedMedia.id}.Success`);
        (0, web_blizzard_reporting_1.reportWebPageShare)({
            sessionTimeSec: 0,
            shareSource: event_1.WebShareSource.WEB_SHARE_BAR,
            webDestinationsAvailable: shareSheetDestinations.join(","),
            webDestinationsSeen: shareSheetDestinations.join(","),
            destinationSelected: clickedMedia.shareDestination,
            shareStatus: event_1.WebShareStatus.WEB_SHARE_STATUS_SUCCESS,
            webPageUrl: shareLink,
            pageType,
            webClientId,
        });
    };
    const handleClick = () => {
        const shareSheetDestinations = shareDestinations.map((shareDestination) => shareDestination.shareDestination.toString());
        setShowModal(true);
        emitSuccessMetrics(pageType, pageName, shareDestinations_1.Embed, shareSheetDestinations);
    };
    const handleMouseOver = (0, react_1.useCallback)(() => {
        setShowTooltip(true);
        timerRef.current = (0, web_env_1.getWindow)()?.setTimeout(() => {
            // hide tooltip
            setShowTooltip(false);
        }, 500);
    }, []);
    (0, react_1.useEffect)(() => () => clearTimeout(timerRef.current), []);
    const tooltipMessage = intl.formatMessage({
        id: "faBe0K",
        description: "Embed tooltip",
        defaultMessage: "Embed",
    });
    const EmbedTrigger = EmbedTriggers_1.EmbedTriggerComponentsMap[triggerComponent];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.default)(isMobile ? EmbedSharing_module_css_1.default.mobileIconContainer : EmbedSharing_module_css_1.default.iconContainer, className), "data-testid": "embedShareIcon", onMouseOver: handleMouseOver, children: [(0, jsx_runtime_1.jsx)(EmbedTrigger, { handleClick: handleClick, buttonSize: isMobile ? "MEDIUM" : "XSMALL" }), showTooltip && ((0, jsx_runtime_1.jsx)("div", { className: EmbedSharing_module_css_1.default.tooltipContainer, "data-testid": "embed-tooltip", children: (0, jsx_runtime_1.jsx)(web_core_ui_1.Tooltip, { message: tooltipMessage, position: web_core_ui_1.Position.TOP }) }))] }, shareDestinations_1.Embed.id), (0, jsx_runtime_1.jsx)(EmbedSharingModal_1.EmbedSharingModal, { showModal: showModal, setShowModal: setShowModal, contentURL: shareLink, title: title, iframeURL: iframeURL, pageType: pageType, webClientId: webClientId })] }));
}
exports.EmbedSharing = EmbedSharing;
//# sourceMappingURL=EmbedSharing.js.map